"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _VersionSetItem = _interopRequireDefault(require("./VersionSetItem"));
var _utils = require("../utils");
/**
 * [Model] SheetItem
 */
var SheetItem = exports["default"] = /*#__PURE__*/function () {
  function SheetItem() {
    (0, _classCallCheck2["default"])(this, SheetItem);
  }
  return (0, _createClass2["default"])(SheetItem, null, [{
    key: "parseV3",
    value:
    /**
     * Parse camel case data
     */
    function parseV3(data) {
      var rowData = data || {};
      var entity = new SheetItem();
      entity.id = rowData.id;
      entity.name = rowData.name;
      entity.collection = rowData.collection;
      entity.originalCollectionName = rowData.originalCollectionName;
      entity.natSortName = rowData.natSortName;
      entity.historyId = rowData.historyId;
      entity.versionSet = _VersionSetItem["default"].parseV3(rowData.versionSet);
      entity.createdAt = _utils.DateUtil.dateStringReformat(rowData.createdAt);
      entity.createdBy = rowData.createdBy;
      entity.createdByName = rowData.createdByName;
      entity.disciplineOrder = rowData.disciplineOrder;
      entity.lastModifiedTime = _utils.DateUtil.dateStringReformat(rowData.updatedAt);
      entity.lastModifiedUserId = rowData.updatedBy;
      entity.lastModifiedUserName = rowData.updatedByName;
      entity.storageUrn = rowData.storageUrn;
      entity.storageSize = rowData.storageSize;
      entity.title = rowData.title;
      entity.fileName = rowData.uploadFileName; // To keep it consistent with document
      entity.uploadId = rowData.uploadId;
      entity.processingState = rowData.processingState;
      entity.bubbleUrn = rowData.bubbleUrn;
      entity.bubbleViewableGuid = rowData.bubbleViewableGuid;
      entity.bubbleViewableOrder = rowData.bubbleViewableOrder;
      entity.bubbleViewableUrn = rowData.bubbleViewableUrn;
      entity.bubbleViewableSize = rowData.bubbleViewableSize;
      entity.tags = rowData.tags;
      entity.isCurrent = rowData.isCurrent;
      entity.deleted = rowData.deleted;
      entity.deletedAt = _utils.DateUtil.dateStringReformat(rowData.deletedAt);
      entity.deletedBy = rowData.deletedBy;
      entity.deletedByName = rowData.deletedByName;
      entity.originalSetName = rowData.originalSetName;
      entity.discipline = rowData.discipline;
      entity.bubbleLargeThumbnailSize = rowData.bubbleLargeThumbnailSize;
      entity.bubbleGiantThumbnailSize = rowData.bubbleGiantThumbnailSize;

      // Fields for search Sheets feature
      entity.highlights = rowData.highlights;
      entity.isIndexPending = !!rowData.isIndexPending;
      return entity;
    }
  }]);
}();